module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-settings/141assets/fonts/fee66e712a8a08eef5805a46892932ad.woff";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass/assets/fonts/font-awesome/fontawesome-webfont.woff?v=4.7.0
// module id = 755
// module chunks = 4